import { FC, useEffect } from 'react';
import AgentChatMessage from '../AgentChatMessage/AgentChatMessage';
import PlusButton from '../../../../../../../assets/images/searchBar/plusButton';
import NudosButton from '../../../../../../../components/NudosComponents/NudosButton/NudosButton';
import BordPhoto from '../../../../../../../components/NudosComponents/BordPhoto/BordPhoto';
import { getNudosData } from '../../../../../../../utils/getNudosData';
import BordAnimationLoader from '../../../../../../../components/BordAnimationLoader/BordAnimationLoader';
import { getHourInAmPmFormat } from '../../../../../../../utils/formatDatesAndHours';
import { IAgentResponseData } from '../../../../../../../types/agentChat.types';
import AgentChatVotingSystem from '../AgentChatVotingSystem/AgentChatVotingSystem';
import './AgentChatMessageList.scss';

interface IAgentChatMessageList {
  question: string;
  isLoading?: boolean;
  error?: boolean;
  agentResponse?: IAgentResponseData;
  handleSetQuestion: (question?: string) => void;
  isHistoryResponse?: boolean;
  refreshHistory: () => Promise<void>;
}

const AgentChatMessageList: FC<IAgentChatMessageList> = ({
  question,
  isLoading,
  error,
  agentResponse,
  handleSetQuestion,
  isHistoryResponse,
  refreshHistory
}) => {
  const userData = getNudosData()?.userData;
  const userPhoto = userData?.photoProfile;
  const currentDateTime = getHourInAmPmFormat(new Date().toISOString())?.onlyHour;
  const userMessageDate = isHistoryResponse
    ? getHourInAmPmFormat(agentResponse?.createdAt || '')?.onlyHour
    : currentDateTime;
  const agentMessageDate = getHourInAmPmFormat(agentResponse?.updatedAt || agentResponse?.createdAt || '')?.onlyHour;

  useEffect(() => {
    return () => handleSetQuestion(undefined);
  }, []);

  return (
    <div className="agentChatMessageList">
      <div className="userChatMessageContainer">
        <AgentChatMessage message={question} messageDate={userMessageDate} />
        <BordPhoto
          size="s32"
          variant="circle"
          url={userPhoto}
          avatarProps={{
            variant: 'circularUser',
            standardSize: 32
          }}
        />
      </div>

      <div className="agentChatMessageContainer">
        <BordPhoto size="s32" avatarProps={{ variant: 'circularBordMascot' }} className="logoImage" />
        {error && <AgentChatMessage isError />}
        {!error && !isLoading && (
          <AgentChatMessage message={agentResponse?.response} messageDate={agentMessageDate} isAgentResponse />
        )}
        {isLoading && !error && <BordAnimationLoader lottieCustomClassName="loadingIndicator" />}
      </div>

      {!error && !isLoading && !!agentResponse?.id && (
        <AgentChatVotingSystem agentChatResponse={agentResponse} refreshHistory={refreshHistory} />
      )}

      {!isLoading && !error && <div className="dividerLine" />}

      {!isLoading && (
        <NudosButton
          buttonText="Iniciar nueva consulta"
          handleClick={() => handleSetQuestion(undefined)}
          customClassName="creatButtonWithIcon"
          buttonIcon={<PlusButton className="iconPositionButton" />}
          iconPosition="left"
          colorPalette="secondary"
        />
      )}
    </div>
  );
};

export default AgentChatMessageList;
